import {Component, OnInit, ViewContainerRef} from '@angular/core';
import {DataService} from "../services/data.service";
import {ToastsManager} from 'ng2-toastr/ng2-toastr';
import {LoginService} from "../services/login.service";
import {Router} from '@angular/router';
import {Idle, DEFAULT_INTERRUPTSOURCES} from '@ng-idle/core';
import {Http, Headers, Response} from '@angular/http';

@Component({
  selector: 'app-personal-cabinet',
  templateUrl: './personal-cabinet.component.html',
  styleUrls: ['./personal-cabinet.component.scss']
})
export class PersonalCabinetComponent implements OnInit {

  activity: boolean;
  timedOut = false;
  idleState = 'Not started.';
  clientId : number;
  clientData : any;
  start : any;
  errorMessage: any;

  constructor(private idle: Idle,
              public router: Router,
              private dataService: DataService,
              private vRef: ViewContainerRef,
              private toastr: ToastsManager,
              private loginService: LoginService,) {

    this.toastr.setRootViewContainerRef(vRef);

    idle.setIdle(1);
    idle.setTimeout(9);
    idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

    idle.onInterrupt.subscribe(() => {
      this.activity = true;
    });
    idle.onTimeout.subscribe(() => {
      this.reset();
    });
    idle.onTimeoutWarning.subscribe(() => {
      this.activity = this.activity ? true : false;
    });
    this.reset();
    this.checkActivite();

  }

  ngOnInit() {

    this.dataService.getPersonalCabinetData().subscribe(
      (data) => {
        this.clientData = data;
        this.clientId = this.clientData.clientId;
      },
      error => {
        this.errorMessage = <any>error;
        error = JSON.parse(error._body);
        this.toastr.error(error.message, error.status_code,{dismiss: 'click'});
        this.router.navigate(['/login']);
      }
    );

  }

  reset() {
    this.idle.watch();
    this.idleState = 'Started.';
    this.timedOut = false;
  }

  checkActivite() {
    this.start = setInterval(() => {

      if (this.clientId) {
        this.SendCabinetActivity();
      }
      this.activity = false;
    }, 6000);
  }

  SendCabinetActivity() {
    this.dataService.sendCabinetActivity(this.clientId, this.activity)
      .subscribe(
        data => {
          data = JSON.parse(data._body);
          if (data.code === 4504) {
            this.loginService.logout();
            clearInterval(this.start);
            this.idle.stop();
          }
        },
        error => {
          error = JSON.parse(error._body);
          this.toastr.error(error.message, error.status_code,{dismiss: 'click'});
          this.loginService.logout();

          clearInterval(this.start);
          this.idle.stop();
        }
      );
  }

  logout() {
    this.loginService.sendLogoutCabinet(this.clientId)
      .subscribe(
        data => {
          this.loginService.logout();
          clearInterval(this.start);
          this.idle.stop();
        }
      );
  }


}



// WEBPACK FOOTER //
// /home/backend/KreditCentr/WebLombard/client/src/app/personal-cabinet/personal-cabinet.component.ts